<template>
    <v-layout wrap row align-center>

        <v-flex sm12>
            <v-flex sm12 class="hour-title pl-3 primary">
                <h2 >{{dateTitle}}</h2>
            </v-flex>
            <v-sheet
                    dark
                    height="325"
                    class="hours-container"
            >
                <p v-if="!intervals || intervals.length == 0" class="pt-5">Sin horarios disponibles</p>
                <v-btn
                        v-for="(interval, i) in intervals"
                        :key="`btn-${i}`"
                        :color="interval.hour === selectedHour.hour ? 'primary lighten-1' : 'grey darken-2'"
                        dark
                        @click="selectedHour = interval"
                >{{interval.hour}}</v-btn>
            </v-sheet>
        </v-flex>
    </v-layout>
</template>

<script>
    export default{
        name: 'HourPicker',
        props: ['date', 'intervals', 'onHourSelect'],
        mounted(){
            this.$moment.locale('es')
            if(this.intervals && this.intervals.length > 0){
                this.selectedHour = this.intervals[0]
            }
        },
        computed:{
          dateTitle(){
              return this.$moment(this.date).format('ddd') + ', ' +
                      this.$moment(this.date).format('D') + ' ' +
                      this.$moment(this.date).format('MMMM') + ' ' +
                      this.$moment(this.date).format('Y') + ''
          }
        },
        data(){
            return{
                selectedHour: {
                    hour: null
                }
            }
        },
        watch:{
            selectedHour(newVal){
                if(typeof this.onHourSelect == 'function'){
                    this.onHourSelect(newVal)
                }
            }
        }
    }
</script>

<style scoped>
    .hour-title{
        height: 50px;
        align-items: center;
        display: flex;
    }

    .hour-title h2{
        color: #fff;
        text-transform: capitalize;
        font-weight: 400;
    }

    .hours-container{
        text-align: center;
        overflow-y: auto;
    }



    /* width */
    ::-webkit-scrollbar {
        width: 3px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
</style>
